
import Layout from "@/components/layout/Layout";
import ProjectForm from "@/components/projects/ProjectForm";

const CreateProject = () => {
  return (
    <Layout>
      <div className="section-container">
        <h1 className="text-4xl font-bold text-center mb-8">
          <span className="text-[#34BF49]">Create Project</span>
        </h1>
        <p className="text-center text-muted-foreground mb-8">
          Showcase your work by adding details and uploading images directly to your portfolio.
        </p>
        <ProjectForm />
      </div>
    </Layout>
  );
};

export default CreateProject;
